import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_ENDPOINTS } from "../config/api";

import Button from "../components/Button";
import { Input } from "../components/Input";
import { Form, FormGroup, Label, FieldDescription } from "../components/Form";
import { ErrorState } from "../components/CommonStates";
import { Card, CardTitle } from "../components/Card";

function Register({ onLogin }) {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    confirmPassword: ""
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const validateForm = () => {
    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.username)) {
      setError("Please enter a valid email address");
      return false;
    }

    // Check minimum length
    if (formData.password.length < 8) {
      setError("Password must be at least 8 characters long");
      return false;
    }

    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!validateForm()) {
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(API_ENDPOINTS.register, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          username: formData.username,
          password: formData.password
        })
      });

      const data = await response.json();

      if (response.ok) {
        onLogin(data.user, data.token);
      } else {
        setError("Sorry, something went wrong.");
      }
    } catch (error) {
      setError("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card>
      <CardTitle>Create account</CardTitle>
      {error && <ErrorState>{error}</ErrorState>}

      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <Label htmlFor="username">Email</Label>
          <Input
            type="email"
            id="username"
            name="username"
            value={formData.username}
            onChange={handleChange}
            required
            disabled={loading}
          />
        </FormGroup>

        <FormGroup>
          <Label htmlFor="password">Password</Label>
          <Input
            type="password"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
            disabled={loading}
            minLength="8"
          />
          <FieldDescription>
            Password must be at least 8 characters long
          </FieldDescription>
        </FormGroup>

        <FormGroup>
          <Label htmlFor="confirmPassword">Confirm password</Label>
          <Input
            type="password"
            id="confirmPassword"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
            disabled={loading}
            minLength="8"
          />
        </FormGroup>

        <Button type="submit" disabled={loading} fullWidth>
          {loading ? "Creating account..." : "Create account"}
        </Button>
      </Form>

      <div style={{ textAlign: "center", marginTop: "2rem", color: "#6c757d" }}>
        Already have an account?{" "}
        <Button variant="link" type="button" onClick={() => navigate("/login")}>
          Login here
        </Button>
      </div>
    </Card>
  );
}

export default Register;
